import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-payment-processor-editor',
    templateUrl: './payment-processor-editor.component.html',
    styleUrls: ['./payment-processor-editor.component.css'],
    standalone: false
})
export class PaymentProcessorEditorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
